const firebaseConfig = {
    apiKey: "AIzaSyBjS1M1yeV8qk45Qfw4xphcf6nzv4WHmgI",
    authDomain: "we-care-3fd4a.firebaseapp.com",
    projectId: "we-care-3fd4a",
    storageBucket: "we-care-3fd4a.appspot.com",
    messagingSenderId: "432335853623",
    appId: "1:432335853623:web:54884ec19c4b9c91c647b2",
    measurementId: "G-RECE4ES2BH"
};
export default firebaseConfig;